import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetMarkets as GetMarketsQuery,
    GetMarkets_markets_edges_node as Market,
} from 'nutshell-graphql-types';

import GET_MARKETS from '../queries/get-markets.graphql';

export const useGetMarkets = (
    shouldSkip?: boolean
): {
    markets: Market[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetMarketsQuery, Record<any, any>>(GET_MARKETS, {
        fetchPolicy: 'cache-and-network',
        skip: shouldSkip,
    });

    const marketsConnection = data ? data.markets : null;

    const markets =
        (marketsConnection &&
            marketsConnection.edges &&
            marketsConnection.edges.map((edge) => edge && edge.node)) ||
        [];

    return {
        markets,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
